import { render, staticRenderFns } from "./ScreenIntro.vue?vue&type=template&id=896b6608&lang=pug"
import script from "./ScreenIntro.vue?vue&type=script&lang=ts"
export * from "./ScreenIntro.vue?vue&type=script&lang=ts"
import style0 from "./ScreenIntro.vue?vue&type=style&index=0&id=896b6608&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports